import { canadaOfferData, canadaStripeUrl } from "../../data/canadaTaxData";
import { ArrowRight, Zap } from "lucide-react";

export const CanadaOfferSection = () => (
  <section id="offer" className="py-24 px-6 bg-[#F3F5F8]">
    <div className="max-w-[87.5rem] mx-auto">
      {/* Heading */}
      <div className="mb-14">
        <span className="text-[#C8283A] text-xs font-black uppercase tracking-[0.2em] mb-3 block" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaOfferData.sectionLabel}
        </span>
        <h2 className="text-[#0B1829] font-black leading-tight mb-3" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(1.8rem, 1.4rem + 2.5vw, 3rem)", letterSpacing: "-0.03em" }}>
          {canadaOfferData.headline1}{" "}
          <span className="text-[#D4A843]">{canadaOfferData.headline2}</span>
        </h2>
        <p className="text-[#5A6A7A] text-base max-w-lg" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
          {canadaOfferData.sub}
        </p>
      </div>

      {/* Value stack card */}
      <div className="bg-white rounded-2xl overflow-hidden border border-[#E8ECF0] shadow-sm max-w-4xl">
        {/* Stack header */}
        <div className="bg-gradient-to-r from-[#0B1829] to-[#132235] px-8 py-5 border-b border-[#D4A843]/20">
          <h3 className="text-[#D4A843] font-black text-lg mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            {canadaOfferData.packageTitle}
          </h3>
          <p className="text-[#8BA3BE] text-xs" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
            {canadaOfferData.packageSub}
          </p>
        </div>

        {/* Items */}
        {canadaOfferData.items.map((item, i) => (
          <div
            key={i}
            className="flex items-start justify-between gap-4 px-8 py-5 border-b border-[#F3F5F8] hover:bg-[#FAFCFF] transition-colors duration-150"
          >
            <div className="flex items-start gap-4 flex-1 min-w-0">
              <div className="w-7 h-7 rounded-full bg-[#FDF1F2] border border-[#C8283A]/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-[#C8283A] text-xs font-black" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{i + 1}</span>
              </div>
              <div className="min-w-0">
                <h4 className="text-[#0B1829] font-bold text-sm mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                  {item.title}
                </h4>
                <p className="text-[#5A6A7A] text-xs leading-relaxed" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                  {item.desc}
                </p>
              </div>
            </div>
            <div className="text-right flex-shrink-0">
              <span className="block text-[#B0BEC5] text-xs line-through">{item.value}</span>
              <span className="block text-[#D4A843] text-xs font-bold mt-0.5" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
                {item.tag}
              </span>
            </div>
          </div>
        ))}

        {/* Total row */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 px-8 py-6 bg-[#FFFDF5] border-t-2 border-[#D4A843]">
          <div>
            <p className="text-[#0B1829] font-black text-base mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              Total Stack Value: <span className="text-[#D4A843]">{canadaOfferData.totalValue}</span>
            </p>
            <p className="text-[#5A6A7A] text-sm" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>
              You're not paying $344. Not paying $150. You're paying the price of a dinner out.
            </p>
          </div>
          <div className="text-right flex-shrink-0">
            <p className="text-[#8BA3BE] text-xs mb-1" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>Your price today:</p>
            <p className="text-[#D4A843] font-black leading-none" style={{ fontFamily: "'Inter', Arial, sans-serif", fontSize: "clamp(2.5rem, 2rem + 1.5vw, 3.5rem)", letterSpacing: "-0.04em" }}>
              $40
            </p>
            <p className="text-[#8BA3BE] text-xs mt-1" style={{ fontFamily: "'Inter', Arial, sans-serif" }}>{canadaOfferData.yourPriceLabel}</p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="text-center mt-10">
        <a
          href={canadaStripeUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="canada-offer-cta"
          className="group inline-flex items-center gap-2.5 bg-[#C8283A] text-white font-black text-sm px-8 py-4 rounded-xl transition-all duration-300 hover:bg-[#A01828] hover:scale-[1.02] active:scale-[0.98] shadow-lg shadow-[#C8283A]/25 uppercase tracking-tight"
          style={{ fontFamily: "'Inter', Arial, sans-serif" }}
        >
          <Zap size={15} className="flex-shrink-0" />
          {canadaOfferData.ctaText}
          <ArrowRight size={15} className="transition-transform group-hover:translate-x-0.5 flex-shrink-0" />
        </a>
      </div>
    </div>
  </section>
);
